import { CommonUrlBasedService, i18nService } from '@meplis/services';
import { AuthenticationService } from './shared/services/application/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@meplis/common';

export function appInitializer(
  authService: AuthenticationService,
  i18nService: i18nService,
  translateService: TranslateService
): () => Promise<void> {
  return async () => {
    let language = 'en';
    const currentLanguages = Object.values(Language);
    const browserLang = translateService.getBrowserLang();

    if (browserLang) {
      const currentLanguageRegex = new RegExp(currentLanguages.join('|'), 'g');
      language = browserLang.match(currentLanguageRegex) ? browserLang : 'en';
    }

    await i18nService.setLanguageAndRegion(language, '', 'meplis-ngage');
    await authService.verifyIfIsLoggedIn();
  };
}
